export const navi = {
  roboRally: {
    "en": "Robo Rally",
    "ja": "ロボラリー"
  },
  storyBook: {
    "en": "Story Book",
    "ja": "ストーリーブック"
  },
  library: {
    "en": "Library",
    "ja": "ライブラリ"
  },
  community: {
    "en": "Community",
    "ja": "コミュニティ"
  },
  help: {
    en: 'Help',
    ja: 'ヘルプ',
  },
  login: {
    en: "Login",
    ja: "ログイン",
  },
  createAccount: {
    en: "Create Account",
    ja: "アカウントを作成",
  },
  myAccount: {
    en: "My Account",
    ja: "マイアカウント",
  },
  logout: {
    en: "Logout",
    ja: "ログアウト",
  },
  language: {
    en: "English",
    ja: "日本語"
  },
  changeLanguage:{
    en: "Change Language",
    ja: "言語の変更"
  }
}